import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Alert } from 'src/app/classes/alert';
import { Roles } from 'src/app/common/roles';
import { AlertService } from 'src/app/services/alert.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ProfileService } from 'src/app/services/profile.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';



@Component({
  standalone: false,
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {
  // @ViewChild('IOSTEST', {static:false}) public iostest: any;
  unsubscribe$: Subject<boolean> = new Subject();
  public coordinatorList: Array<any> = new Array<any>();
  public driverList: Array<any> = new Array<any>();
  expandedPanel = -1;
  constructor(
    private logger: LoggerService,
    private alertService: AlertService,
    private profileService: ProfileService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    const userRoles = this.profileService.profileObs$.getValue().userRoles;
    if(userRoles.includes(Roles.DRIVER) || userRoles.includes(Roles.COORDINATOR)){
      this.subscribeToAlertData();
    }
  }

  setExpandedpanel(alert: Alert): void {
    this.expandedPanel = alert.alertId;
  }

  private subscribeToAlertData() {
    this.alertService.getAlertData()
    .pipe(
      takeUntil(this.unsubscribe$))
      .subscribe(alertData => {
          const isCoordinator = this.profileService.profileObs$.getValue().userRoles.includes(Roles.COORDINATOR);
          if(alertData){
            this.coordinatorList = new Array<Alert>();
            this.driverList = new Array<Alert>();

            let profile = this.profileService.profileObs$.getValue();
            let adId = profile.adId || '?';

            alertData.forEach( (alert) => {
              // if coordinator then get all driver alerts so coordinators can see them in driver alert tab
              if(isCoordinator && alert.old === false && alert.alertUsrType === "DRIVER"){
                this.driverList.push(alert);
              }
              if (isCoordinator && alert.old === false && alert.alertUsrType === "COORDINATOR") {
                this.coordinatorList.push(alert);
              }

              if (alert.userId && alert.userId.toUpperCase() === adId.toUpperCase() && alert.old === false) {

                if (!isCoordinator && alert.alertUsrType === "DRIVER") {
                  this.driverList.push(alert);
                }

                //show dialog to coordinator only if critial alert
                if(isCoordinator && alert.alertMsg.critical && alert.acknowledgeIndicator === false && this.dialog.openDialogs.length==0){
                  this.logger.debug(`updateAlertForNativeMobile fired`, 'ui');
                  this.alertService.updateAlertForNativeMobile({message: alert.alertMsg.msg, type: alert.alertUsrType})
                  this.showAlertModal(alert);
                //show dialog to driver only if not critial alert
                }else if (!isCoordinator && alert.acknowledgeIndicator === false && !alert.alertMsg.critical && this.dialog.openDialogs.length==0){
                  this.logger.debug(`updateAlertForNativeMobile fired`, 'ui');
                  this.alertService.updateAlertForNativeMobile({message: alert.alertMsg.msg, type: alert.alertUsrType})
                  this.showAlertModal(alert);
                }else{
                 // this.logger.debug("Do Nothing for this alert since it has been acknowledged already:", alert);
                }
              }
            });
            this.alertService.updateMeatballData({coordinator: this.coordinatorList.length, driver: this.driverList.length});
          }
      })
  }


  showAlertModal(alert: Alert){
    this.dialog.open(AlertDialogComponent,{
      data: {
        id: alert.alertId,
        message: alert.alertMsg.msg
      },
      disableClose: true,
      position: { top: '0'},
      panelClass: 'cvv-alert-panel'
    });
  }


  alertCounterMeatball() {
  // TODO implement the alert counter meatball for display on the nav bar icon
  }

}
